interface ProPlanFeatureOptions {
  chatMessageFeatureLabel?: string;
}

const DEFAULT_PRO_CHAT_MESSAGE_FEATURE_LABEL = "Unlimited Classic Chat messages";

export const getProPlanFeatures = ({
  chatMessageFeatureLabel = DEFAULT_PRO_CHAT_MESSAGE_FEATURE_LABEL,
}: ProPlanFeatureOptions = {}): string[] => [
  "Dark mode",
  "Unlimited notes",
  chatMessageFeatureLabel,
  "Unlimited collections",
  "Unlimited API keys",
  "Unlimited PDFs in search and chat",
];

export const PROACTIVE_PLAN_FEATURES = [
  "Reminds you before things slip—without being asked",
  "Catches commitments you never asked it to track",
  "Learns what matters to you from everything you put in Mem",
  "Mem Agent in Slack, iMessage, and WhatsApp",
  "Custom routines and external connections",
];

export const PROACTIVE_COMPARISON_PLAN_FEATURES = [
  "Includes legacy Pro access",
  ...PROACTIVE_PLAN_FEATURES,
];
